import { render } from "./SurveyList.vue?vue&type=template&id=0032f042&scoped=true"
import script from "./SurveyList.vue?vue&type=script&lang=js"
export * from "./SurveyList.vue?vue&type=script&lang=js"

import "./SurveyList.vue?vue&type=style&index=0&id=0032f042&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0032f042"]])

export default __exports__